export const setBoughtProducts = (details) => ({
    type: "SET_BOUGHTPRODUCTS",
    details
})
export const setBoughtUsers = (user) => ({
    type: "SET_BOUGHTUSER",
    user
})